export function SectionControllerBase($scope, $analytics) {

  let controllerNameForAnalytics = null;

  $scope.setControllerName = function(controllerName) {
    controllerNameForAnalytics = controllerName;
  };

  $scope.toggleCollapseClick = function($event) {
    if ($event) {
      $event.stopPropagation();
    }
    if($scope.isCollapsed) {
      $scope.expand();
      $analytics.eventTrack('clickExpand', { category: controllerNameForAnalytics });
    } else {
      $scope.collapse();
      $analytics.eventTrack('clickCollapse', { category: controllerNameForAnalytics });
    }
  }

  $scope.collapse = function() {
    $scope.isCollapsed = true;
    $scope.collapseDiv = 'hoverDiv';
  }

  $scope.expand = function() {
    $scope.isCollapsed = false;
    delete $scope.collapseDiv;
  }

  if ($scope.isCollapsed == undefined) {
    $scope.collapse();
  }
};

export default [
  '$scope',
  '$analytics',
  SectionControllerBase
]
